var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRemixTemplate = function SvgIconRemixTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M14.391 14H5.016c-.182 0-.312-.16-.312-.342V12.17a1 1 0 0 1 .332-.745l1.393-1.249a1.19 1.19 0 0 1 1.55 0l.024.022a1 1 0 0 0 1.4-.064l1.653-1.78a1.178 1.178 0 0 1 1.673-.009l1.698 1.776a1 1 0 0 1 .277.691v2.846c0 .182-.13.342-.313.342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M2.963 2.252c-.982 0-1.778.796-1.778 1.777v4.623a.593.593 0 0 1-1.185 0V4.029a2.963 2.963 0 0 1 2.963-2.963h9.47c1.119 0 2.026.908 2.026 2.027a.593.593 0 0 1-1.185 0 .84.84 0 0 0-.842-.841z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M14.815 0c.327 0 .592.265.592.593v2.844a.71.71 0 0 1-.71.711H11.97a.593.593 0 1 1 0-1.185h2.252V.593c0-.328.266-.593.593-.593M12.444 13.748c.982 0 1.778-.795 1.778-1.777V7.348a.593.593 0 0 1 1.185 0v4.623a2.963 2.963 0 0 1-2.963 2.963h-9.47a2.027 2.027 0 0 1-2.026-2.027.593.593 0 1 1 1.185 0c0 .464.377.841.842.841z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M.593 16A.593.593 0 0 1 0 15.407v-2.844c0-.393.318-.711.711-.711h2.726a.593.593 0 1 1 0 1.185H1.185v2.37A.593.593 0 0 1 .593 16",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    d: "M5.867 8.327a1.165 1.165 0 0 0 0-2.327 1.165 1.165 0 0 0 0 2.327"
  })));
};
export default SvgIconRemixTemplate;